import React from 'react';
import PropTypes from 'prop-types';
import {
  SimpleModal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from '@ami/react/core';
import { Button } from '@ami/react/core';
import { FormInput } from '@ami/react/core';
import { ordersService } from '../../../orders/ordersService';

export default class CustomActivityModal extends React.Component {
  state = {
    show: false,
    saving: false,
    message: '',
  };

  static propTypes = {
    orderId: PropTypes.string.isRequired,
    onChanged: PropTypes.func.isRequired,
  };

  show() {
    this.setState({ show: true, message: '' });
  }

  hide = () => this.setState({ show: false });

  save = () => {
    this.setState({ saving: true });
    ordersService
      .addCustomActivity(this.props.orderId, this.state.message)
      .then(() => {
        this.props.onChanged();
        this.hide();
      })
      .finally(() => this.setState({ saving: false }));
  };

  render() {
    if (!this.state.show) return null;
    return (
      <SimpleModal show={this.state.show}>
        <ModalHeader title="Add Custom Activity" />
        <ModalBody>
          <form className="container">
            <div className="row">
              <div className="col">
                <FormInput
                  label="Message"
                  placeholder="Enter a message"
                  type="textarea"
                  //textAreaAutoRows={true}
                  rows={2}
                  value={this.state.message}
                  onChange={(e) => this.setState({ message: e.target.value })}
                />
              </div>
            </div>
          </form>
        </ModalBody>
        <ModalFooter>
          <button className="btn btn-secondary" onClick={this.hide}>
            Cancel
          </button>
          <Button
            label="Save"
            className="btn btn-primary"
            onClick={this.save}
            showSpinner={this.state.saving}
            disabled={this.state.saving}
          />
        </ModalFooter>
      </SimpleModal>
    );
  }
}
